export const weatherTabTypes = [
  {
    label: 'Rain',
    value: 'rain',
  },
  {
    label: 'Temperature',
    value: 'temperature',
  },
]